import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import PrimaryContactTable from "./PrimaryContactTable"

import { Button } from "@/components/common/Button"
import type { Location } from "@/graphql/codegen/graphql"
import { formatLocationAddress } from "@/utils/utils"

interface SetPrimaryContactProps {
  location: Location
  companyId: string
  currentContactId: string | null
  onConfirm: (contactId: string) => void
  onClose: () => void
  showCurrentContact?: boolean
}
const SetPrimaryContact: FC<SetPrimaryContactProps> = ({
  location,
  companyId,
  currentContactId,
  onConfirm,
  onClose,
  showCurrentContact = true,
}) => {
  const locationName = formatLocationAddress(location)

  const [selectedPrimaryContactId, setSelectedPrimaryContactId] = useState<string | null>(
    showCurrentContact ? currentContactId : null
  )
  const submitDisabled = showCurrentContact ? selectedPrimaryContactId === currentContactId : !selectedPrimaryContactId

  return (
    <Dialog open={true} fullWidth={true} maxWidth='sm' onClose={onClose}>
      <DialogTitle className='pb-3 pl-10 font-normal text-primary'>Edit Primary Contact</DialogTitle>
      <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-4 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
      <DialogContent classes={{ root: "p-10" }}>
        <Typography variant='body1' fontWeight={400} className='mb-4 text-ml tracking-[0.15px] text-gray-700'>
          Location Name
        </Typography>
        <Typography>{locationName}</Typography>
        <Typography variant='body1' fontWeight={400} className='mt-6 text-ml tracking-[0.15px] text-gray-700'>
          Location Contacts
        </Typography>
        <Box className='max-h-[440px] overflow-y-auto'>
          <PrimaryContactTable
            showCurrentContact={showCurrentContact}
            currentContactId={currentContactId}
            companyId={companyId}
            locationId={location.locationId}
            selectedPrimaryContactId={selectedPrimaryContactId}
            setSelectedPrimaryContactId={setSelectedPrimaryContactId}
          />
        </Box>
      </DialogContent>
      <DialogActions className='justify-between px-10 pb-10'>
        <Button appearance='outlined' onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={() => onConfirm(selectedPrimaryContactId as string)} disabled={submitDisabled}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SetPrimaryContact
